var map = {
	"./banner.jpg": "4141",
	"./banner_en.jpg": "7e61",
	"./banner_es.jpg": "43d8",
	"./banner_hk.jpg": "a001",
	"./banner_pt.jpg": "9bf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15ee";